import { ref, computed, watch } from 'vue'

import useAuthenticated from './useAuthenticated'
import usePermissions from './usePermissions'

const loaded = ref(false)

function ttgChatOnReady() {
  loaded.value = true
}

window.ttgChatOnReady = ttgChatOnReady

export default function useHubSpotConversation() {
  const hasParent = window.self !== window.top

  const { authenticating } = useAuthenticated()
  const { isStaff } = usePermissions()

  const visible = computed(() => {
    if (authenticating.value) return false
    if (loaded.value === false) return false
    if (hasParent) return false
    if (isStaff.value) return false
    return true
  })

  watch(
    visible,
    (v) => {
      if (v) {
        load()
        return
      }

      hide()
    },
    { immediate: true },
  )

  function hide() {
    if (window.ttgChat === undefined) return
    window.ttgChat.hide()
  }

  function load() {
    if (window.ttgChat === undefined) return
    window.ttgChat.show()
  }
}
